import { 
    // useEffect, 
    // useState, 
    useContext, 
    // useCallback, 
    createContext 
} from 'react';
// import { toast } from 'react-toastify';
// import { api } from '../../../../../services/api'

const OrdersContext = createContext()


export const OrdersProvider = ({ children }) => {

    return (
        <OrdersContext.Provider value={{ 
        }}>
            {children}
        </OrdersContext.Provider>
    );
}


export function useOrders() {
    const context = useContext(OrdersContext);

    if(!context) {
        throw new Error('useOrders must be used within an Provider');
    }

    return context;
}